export const SESSION_STORAGE = {
  LS_SKIP_START_BUTTON: 'LS_SKIP_START_BUTTON',
};
